import type { Dictionary } from "@/dictionaries/types";

/**
 * THE SEVEN THINGS A VISITOR CAN SEARCH FOR, in the order they are shown.
 *
 * The values are the `?type=` vocabulary of /search, so the five the legacy
 * page already used (`user`, `collection`, `nft`, `drops`, `blogs`) keep
 * every shared link working; `auctions` and `galleries` are new.
 */
export const SEARCH_KINDS = ["user", "collection", "nft", "drops", "auctions", "galleries", "blogs"] as const;
export type SearchKind = (typeof SEARCH_KINDS)[number];

export const SEARCH_TYPES = ["all", ...SEARCH_KINDS] as const;
export type SearchType = (typeof SEARCH_TYPES)[number];

/** The backend rejects shorter text with a 422 (`text` min:3), everywhere. */
export const MIN_QUERY = 3;
/** `POST /search` caps `count` at 10 (12 answers 422); every source asks for the same. */
export const RESULT_COUNT = 10;

export function kindLabel(kind: SearchType, dict: Dictionary): string {
  const t = dict.search;
  const labels: Record<SearchType, string> = {
    all: t.typeAll, user: t.typeUser, collection: t.typeCollection, nft: t.typeNft,
    drops: t.typeDrops, auctions: t.typeAuctions, galleries: t.typeGalleries, blogs: t.typeBlogs,
  };
  return labels[kind];
}

export function sectionLabel(kind: SearchKind, dict: Dictionary): string {
  const t = dict.search;
  const labels: Record<SearchKind, string> = {
    user: t.sectionUsers, collection: t.sectionCollections, nft: t.sectionNfts, drops: t.sectionDrops,
    auctions: t.sectionAuctions, galleries: t.sectionGalleries, blogs: t.sectionBlogs,
  };
  return labels[kind];
}

/** Where "browse all of this kind" goes when a search finds none of it. */
export const KIND_BROWSE: Record<SearchKind, string> = {
  user: "/artists", collection: "/collection", nft: "/market", drops: "/drops",
  auctions: "/auctions", galleries: "/galleries", blogs: "/blogs",
};
